<template>
    <div class="video-wrapper">
        <layout>
            <div slot="content" class="con">
                <swiper
                    v-if="list.length > 0"
                    :options="swiperOption"
                    ref="swiperOption"
                    class="swiperWrap"
                >
                    <swiper-slide
                        v-for="(items, index) in list"
                        :key="index"
                        class="swiperItem"
                    >
                        <div class="videobg">
                            <img :src="items.cover.file_path" alt="" />
                            <i class="iconfont iconbofang1" @click="Jump(items.url)"></i>
                        </div>
                        <div class="title">
                            <p>{{ items.title }}</p>
                        </div>
                    </swiper-slide>
                    <div class="pagWrap" slot="pagination"></div>
                </swiper>
            </div>
        </layout>
    </div>
</template>
<script>
import { getVideoList } from "@/api/http.js";
import layout from "@/components/layout.vue";
import { Swipe, SwipeItem } from "vant";
import Vue from "vue";
Vue.use(Swipe).use(SwipeItem);
export default {
    components: {
        layout,
    },
    data() {
        return {
            list: [],
            swiperOption: {
                watchSlidesProgress: true,
                slidesPerView: "auto",
                centeredSlides: true,
                loop: false,
                loopedSlide: 5,
                autoplay: false,
                on: {
                    progress: function (progress) {
                        for (let i = 0; i < this.slides.length; i++) {
                            let slide = this.slides.eq(i);
                            let slideProgress = this.slides[i].progress;
                            let modify = 1;
                            // if (Math.abs(slideProgress) > 1) {
                            //   modify = (Math.abs(slideProgress) - 1) * 0.1 + 1;
                            // }
                            let translate = slideProgress * 279 + "px";
                            let scale = 1 - Math.abs(slideProgress) / 5;
                            let zIndex =
                                100 - Math.abs(Math.round(10 * slideProgress));

                            slide.transform(
                                "translateX(" +
                                    translate +
                                    ") scale(" +
                                    scale +
                                    ")"
                            );
                            slide.css("zIndex", zIndex);
                            slide.css("opacity", 1);
                            if (Math.abs(slideProgress) > 3) {
                                slide.css("opacity", 0);
                            }
                        }
                    },
                    setTransition: function (transition) {
                        for (let i = 0; i < this.slides.length; i++) {
                            let slide = this.slides.eq(i);
                            slide.transition(transition);
                        }
                    },
                },
                pagination: {
                    el: ".pagWrap",
                    clickable: false,
                    type: "progressbar",
                    progressbarFillClass: "swpagination",
                    renderProgressbar: function (progressbarFillClass) {
                        return (
                            '<span class="' +
                            progressbarFillClass +
                            '" ></span>'
                        );
                    },
                },
            },
        };
    },

    created() {
        getVideoList().then((res) => {
            this.list = res.data.data;

            if(process.env.VUE_APP_ISAPP=='true'){
                    this.list.forEach(item=>{
                        item.url = './models/modelVideos/' + this.getVideoName(item.pad_video_id,item.url)
                        item.cover.file_path = './models/modelImgs/' + this.getVideoName(item.pad_video_id,item.cover.file_path)
                    })
                }
        });
    },

    methods: {
        getVideoName(modelId,modelURL){
			const tempArr = modelURL.split('.')
			let suffix = tempArr[tempArr.length-1]
			let fileName = modelId +'.' + suffix
			return fileName
		},
        Jump(path) {
            this.$router.push({
                path: '/videoDetail',
                query: {
                  path
                }
            })
         
        },
    },
};
</script>
<style lang="scss" scoped>
.video-wrapper {
    width: 100vw;
    height: 100vh;
}
/deep/.swiper-wrapper{
    width: 100vw;
    height: 100vh;
}
.con {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;

    background: url("../../assets/img/detailbg.jpg");
    background-size: 100%100%;
    .swiperWrap {
        padding: 10px;

        width: 100vw;
        height: 100vh;
        box-sizing: border-box;
        .swiperItem {
            width: 100vw;
            height: 100vh;
            box-shadow: 0 0 20px #5a4e35;
            .videobg {
                width: 100%;
                height: 100%;
                overflow: hidden;
                position: relative;
                img {
                    width: 100vw;
                    height: 100vh;
                }
                i {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 35px;
                    color: #333333;
                    background: rgba($color: #fff, $alpha: 0.7);
                    height: 70px;
                    line-height: 70px;
                    text-align: center;
                    width: 70px;
                    border-radius: 50%;
                }
            }
            .title {
                height: 60px;
                background: #2c2c2c;
                overflow: hidden;
                p {
                    height: 44px;
                    width: 446px;
                    margin: 8px auto;
                    line-height: 44px;
                    font-size: 16px;
                    text-align: center;
                    background: url("../../assets/img/bordertop.png");
                    background-size: 100%100%;
                    color: #d6ad58;
                }
            }
        }
    }
}
</style>
<style>
/* .pagWrap {
    right: 10px;
    top: 50%;
    transform: translate3d(0, -50%, 0);
    position: absolute;
    text-align: center;
    -webkit-transition: 0.3s opacity;
    -o-transition: 0.3s opacity;
    transition: 0.3s opacity;
    z-index: 10;
    bottom: initial !important;
    left: initial !important;
    width: initial !important;
} */
.pagWrap {
    background: #d6d6d6;
    height: 5px !important;
    width: 300px !important;
    position: fixed;
    bottom: 50px !important;
    z-index: 10;
    left: 50% !important;
    top: initial !important;
    transform: translateX(-50%);
}
.swpagination {
    background: #c9a864;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: left top;
    -ms-transform-origin: left top;
    transform-origin: left top;
}
.DetailItem {
    border-radius: 100%;
    background: #fff;
    opacity: 0.7;
    width: 8px;
    height: 8px;
    margin: 10px 0;
    display: block;
    line-height: 26px;
}
.DetailItemactive {
    background: #c9a864;
    opacity: 1;
}
</style>
